<template>
  <modal
    class="payment-modal"
    :width="width"
    :height="height"
    name="payment-modal"
    :clickToClose="showCloseButton"
    transition="pop-out"
    @before-open="beforeOpen"
    @opened="opened"
    @closed="closed"
  >
    <div v-if="loading" class="loading">
      <div class="holder">
        İşleminiz Gerçekleştiriliyor<br/>
        Lütfen Bekleyiniz<br/>
        <i class="fas fa-spin fa-spinner"></i>
      </div>
    </div>
    <div class="error" v-if="error">
      <div class="holder">
        <i class="fas fa-exclamation-circle"></i>
        <h4>Bir Sorun Gerçekleşti</h4>
        <p v-html="error"></p>
      </div>
    </div>
    <iframe ref="iframe" src="" frameborder="0"></iframe>
    <button class="close" v-if="showCloseButton" @click="$modal.hide('payment-modal')"><i class="fas fa-times"></i></button>
  </modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      showCloseButton: false,
      width: 600,
      height: 500,
      error: null,
      params: null
    }
  },
  created() {
    this.width = Math.min(window.innerWidth - 20, 500)
    this.height = Math.min(window.innerHeight - 20, 500)
  },

  methods: {
    ...mapActions(['clearBasket']),

    makePayment() {
      this.$http.post('v2/payment', this.params)
        .then((res) => {
          if (res.data.success) {
            const iframe = this.$refs.iframe.contentWindow
              || this.$refs.iframe.contentDocument.document
              || this.$refs.iframe.contentDocument

            iframe.document.open()
            iframe.document.write(res.data.html)
            iframe.document.close()
          } else {
            this.showCloseButton = true
            this.error = res.data.message
          }
        }).catch((err) => {
          this.showCloseButton = true
          this.error = err.response.data.message

          if (err.response.data.errors) {
            this.error = 'Girdiğiniz Bilgiler Geçersiz.<br/>'
            this.error += Object.values(err.response.data.errors)
              .flatMap(item => item)
              .join('<br/>')
          }
        }).finally(() => {
          this.loading = false
        })
    },

    paymentResponse(data) {
      if (data.success) {
        this.clearBasket()
        this.$root.$emit('clear_cart')

        const token = this.user.loggedIn ? '' : `?token=${data.token}`
        this.$router.push(`/odeme-sonuc/${data.receipt_id}${token}`)

        this.$modal.hide('payment-modal')
      } else {
        this.showCloseButton = true
        this.error = data.message
      }
    },
    opened() {
      if (this.user.loggedIn) {
        this.makePayment()
      } else {
        const name = this.params.donator_name.trim().split(' ')
        this.$http.post('v2/user/register', {
          last_name: name.pop(),
          first_name: name.join(' '),
          country_phone_code: this.params.country_phone_code,
          phone_number: this.params.donator_phone
        }).then((res) => {
          this.$store.commit('loggedIn', res.data)
          this.makePayment()
        }).catch((err) => {
          if (err.response.status === 409) {
            this.makePayment()
          } else {
            this.showCloseButton = true
            this.error = err.response.data.message

            if (err.response.data.errors) {
              this.error = 'Girdiğiniz Bilgiler Geçersiz.<br/>'
              this.error += Object.values(err.response.data.errors)
                .flatMap(item => item)
                .join('<br/>')
            }
          }
        })
      }
    },
    beforeOpen(event) {
      this.error = null
      this.loading = true
      this.showCloseButton = false
      this.params = event.params.data
      this.$root.$on('payment-response', this.paymentResponse)
    },
    closed() {
      this.$root.$off('payment-response', this.paymentResponse)
    }
  }
}
</script>
<style>
  .payment-modal .loading, .payment-modal .error {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
  }

  .payment-modal .error {
    background-color: #ffd8d6;
    z-index: 3;
    color: #c60100;
    font-size: 45px
  }

  .payment-modal .error p {
    font-size: 24px;
  }

  .payment-modal .loading .holder {
    font-size: 24px;
  }

  .payment-modal .close {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 30px;
    height: 30px;
    background-color: #ff7070;
    color: white;
    border-radius: 20px;
    text-align: center;
    border: none;
    z-index: 55;
  }

  .payment-modal iframe {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
</style>
